var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5556 17V17.0172M1 33H33M6.33333 33V4.55556C6.33333 3.61256 6.70794 2.70819 7.37473 2.0414C8.04153 1.3746 8.9459 1 9.88889 1H24.1111C25.0541 1 25.9585 1.3746 26.6253 2.0414C27.2921 2.70819 27.6667 3.61256 27.6667 4.55556V33",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHall);
export default __webpack_public_path__ + "static/media/hall.e680d66b81c85a64fcb075b246064fb1.svg";
export { ForwardRef as ReactComponent };